import { BaseContainerModel } from '../base-container.model';
import { PostCommentContainerModel } from '../post-comment';
import { PostCommentLoginSubjectReactionLinksContainerModel } from '../post-comment-login-subject-reaction-links/post-comment-login-subject-reaction-links.model';

export class PostCommentWithReactionContainerModel extends BaseContainerModel {
  cmsPostCommentContainer: PostCommentContainerModel = new PostCommentContainerModel();
  cmsPostCommentLoginSubjectReactionLinkContainer: PostCommentLoginSubjectReactionLinksContainerModel[] = [];
  totalLikes: Number = new Number();
}
